import React from 'react';

import { SelectionCustomCargoType } from '../types';
import CustomCargoBase from './CargoSelectionBase';
import CustomCargoPallet from './CargoSelectionPallet';
import CustomCargoVolume from './CargoSelectionVolume';
import { CargoSelectionItemProps } from './types';

type Type = {
  [key in SelectionCustomCargoType]: React.FC<CargoSelectionItemProps>;
};

const CargoSelectionItem: React.FC<CargoSelectionItemProps> = (props) => {
  const { cargoType } = props;
  const components: Type = {
    base: CustomCargoBase,
    pallet: CustomCargoPallet,
    volume: CustomCargoVolume,
  };

  const Component = components[cargoType];

  return <Component {...props} />;
};

export { CargoSelectionItem };
